import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from '../stores/Hooks';

export const YandexCaptchaComponent: React.FC<any> = observer(
	() =>
	{
		const { uiState } = useStores();
		const store = uiState.captcha;

		React.useEffect(() =>
		{
			if (!store.ShowModal) return;
			if (!(window as any).smartCaptcha)
			{
				store.Callback("NO smartCaptcha");
				store.setShowModal(false);
			}

			(window as any).smartCaptcha.render(myRef.current,
				{
					sitekey: store.PublicKey,
					hl: 'ru',
					callback: (token: string):void =>
					{
						store.setShowModal(false);
						(window as any).smartCaptcha.reset();
						store.Callback(token);
					}
				}
			);
		});

		if (!store.ShowModal)
		{
			document.body.classList.remove('modal-show');
			return (null);
		}

		document.body.classList.add('modal-show');
		const myRef = React.createRef<HTMLDivElement>();

		return (
			<>
				{
					store.ShowModal &&
					<>
						<div className="modal-background"></div>
						<div className="modal d-flex align-items-center justify-content-center">
							<div className="modal-container">
								<div ref={myRef} style={{ height: 100 }}></div>
							</div>
						</div>
					</>
				}
			</>
		);
	}
)
